import { User } from "./userTypes";

export interface UserPermissionGrid {
  id: number;
  name: string;
  email: string;
  position: string;
  groups: string[];
  vessels: string[];
}

export interface UserPermissionGroup {
  group_id: number; //id of the group
  id: number; //id of the user in the group
  permissions: GroupPermission[];
  vessels: string[];
}

export interface UserPermissionByIdResponse {
  id: number;
  name: string;
  email: string;
  position: string;
  user_groups: UserPermissionGroup[];
}

export interface PermissionBody {
  user_group_id?: number;
  group_id: number;
  vessels: string[];
  permissions_id?: number[];
}

export interface UserPermissionBody {
  name: string;
  email: string;
  position: string;
  permissions: PermissionBody[];
}

export interface UserPermissionFormValues extends Omit<UserPermissionBody, "position"> {
  position_id: number | null;
}

export interface GroupPermissionBody {
  name: string;
  permission_ids: number[];
  recommended_position: string;
}

export interface CreateGroupPermissionResponse {
  id: number[];
}

export interface CreatePermissionResponse {
  user_group_ids: number[];
}

export interface GroupPermission {
  id: number;
  enable: boolean;
  description: string;
  name: string;
}

export interface GroupInfo {
  id: number;
  name: string;
  recommended_position: string;
}

export interface GroupPermissionResponse extends GroupInfo {
  permissions: GroupPermission[];
}

export interface PermissionGroupResponse extends GroupPermissionResponse {
  linked_users: string[];
}

export interface HistoryGroupPermissionChanges {
  change_date: any;
  changed_by: {
    mail: string;
    name: string;
    position: string;
  };
  group: {
    active: boolean;
    name: string;
    permissions: string[];
    recommended_position: string;
  };
}

export interface HistoryGroupPermissionResponse {
  changes?: HistoryGroupPermissionChanges[];
  group: GroupInfo;
}

export interface PermissionOptionsResponse {
  description: string;
  enable: boolean;
  id: number;
  name: string;
}

interface UserGroupsHistory {
  permissions: string[] | null;
  user_group: string;
  vessels: string[];
}

interface PermissionHistoryChange {
  change_date: Date;
  changed_by: User;
  user_groups: UserGroupsHistory[];
}

export interface PermissionHistoryResponse {
  changes: PermissionHistoryChange[];
  user: User;
}

export enum GroupEnum {
  SHAPE_ADMIN = 1,
  VESSEL_ADMIN = 2,
  PROCESS_SAFETY_LEAD = 3,
  OPS_MANAGER = 4,
  CUSTOM = 5,
}

export enum GroupLabelsEnum {
  SHAPE_ADMIN = "Shape's Admin",
  VESSEL_ADMIN = "Vessel Admin",
  PROCESS_SAFETY_LEAD = "Process Safety Lead",
  OPS_MANAGER = "Ops. Manager",
  CUSTOM = "Custom",
}

export type Permission =
  | CtoPermissions
  | CtoManagerPermissions
  | OthersPermissions;

export enum CtoPermissions {
  IDENTIFICATION = 1,
  INITIATION = 2,
  EVALUATION = 3,
  REVIEW = 4,
  APPROVAL = 5,
  MITIGATION = 6,
  REASSESSMENT = 7,
  VERIFICATION = 8,
  CLOSURE = 9,
}

export enum NewCtoPermissions {
  REVIEW_AND_APPROVAL = 4,
  VERIFICATION_AND_CLOSURE = 9,
}

export enum CtoManagerPermissions {
  EXTEND = 10,
  CLOSE = 11,
}

export enum OthersPermissions {
  CHANGE_WO = 12,
  MANAGE_REQUEST = 13,
  PERMISSIONS = 14,
  // DELETE_CTO = 15,
  // BYPASS = 16,
  GROUP_CTO = 17,
}

export const stepToPermissionMap: Record<
  number,
  CtoPermissions | NewCtoPermissions
> = {
  0: CtoPermissions.IDENTIFICATION,
  1: CtoPermissions.INITIATION,
  2: CtoPermissions.EVALUATION,
  3: NewCtoPermissions.REVIEW_AND_APPROVAL,
  4: CtoPermissions.MITIGATION,
  5: CtoPermissions.REASSESSMENT,
  6: NewCtoPermissions.VERIFICATION_AND_CLOSURE,
};
